import React from 'react';
import { pathname } from '../../../utils/path/path';
import Content from '../../../components/Onboarding/GetStarted/Revenue';

export default function Revenue() {
  return (
    <Content
      progressBarPath={pathname.preLogin.getStarted}
      backButtonPath={pathname.preLogin.getStarted.platform.url}
      continuePath={pathname.preLogin.getStarted.accountCreation.url}
    />
  );
}
